import { useState } from "react";

export default function GeneralTab() {
  const [showDialog, setShowDialog] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [error, setError] = useState("");
  const [verified, setVerified] = useState(false);

  const handleEmailSubmit = () => {
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail);
    if (!isValid) {
      setError("The email you entered is incorrect");
      setVerified(false);
    } else {
      setError("");
      setVerified(true);
    }
  };

  return (
    <>
      {/* Main Form */}
      <div className="flex flex-row gap-28 items-start flex-wrap">
        <span className="text-2xl min-w-[120px]">General</span>
        <div className="flex flex-col flex-1">
          <form className="space-y-6 w-full md:w-[722px]">
            {/* Company Name */}
            <div className="flex flex-col items-start gap-[7px] h-[74px] w-full">
              <label className="text-base font-medium text-gray-700">
                Company name
              </label>
              <input
                type="text"
                placeholder="This is the details about the company"
                className="w-full rounded-md p-2 bg-[#F4F4F4]"
              />
            </div>

            {/* About */}
            <div className="flex flex-col items-start gap-[7px] w-full">
              <label className="text-base font-medium text-gray-700">
                About
              </label>
              <textarea
                rows={8}
                placeholder="This is the details about the buyer"
                className="w-full bg-[#F4F4F4] rounded-md p-2"
              />
            </div>

            {/* Email */}
            <div className="flex flex-col items-start gap-[7px] w-full">
              <label className="text-base font-medium text-gray-700">
                Email
              </label>
              <div className="flex w-full gap-2">
                <input
                  type="email"
                  defaultValue="user@email.com"
                  className="bg-[#F4F4F4] rounded-md p-2 flex-1"
                />
                <button
                  type="button"
                  onClick={() => setShowDialog(true)}
                  className="border text-[#545454] px-4 py-2 rounded-md w-[150px]"
                >
                  Change email
                </button>
              </div>
            </div>

            {/* Password */}
            <div className="flex flex-col items-start gap-[7px] w-full">
              <label className="text-base font-medium text-gray-700">
                Password
              </label>
              <div className="flex w-full gap-2">
                <input
                  type="password"
                  placeholder="Current password"
                  className="bg-[#F4F4F4] rounded-md p-2 flex-1"
                />
                <button
                  type="button"
                  className="border text-[#545454] px-4 py-2 rounded-md w-[150px] whitespace-nowrap"
                >
                  Change password
                </button>
              </div>
            </div>

            {/* Save Button */}
            <button
              type="submit"
              className="bg-[#EAF524] text-black px-6 py-2 rounded-md mt-6"
            >
              Save changes
            </button>
          </form>
        </div>
      </div>

      {/* Dialog */}
      {showDialog && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center"
          style={{ zIndex: 10000 }}
        >
          <div className="bg-white rounded-lg shadow-lg p-12 w-[636px] flex flex-col items-start">
            {!verified ? (
              <>
                <h2 className="text-lg font-semibold text-[#1D2739] text-left">
                  Change Email
                </h2>
                <p className="text-base text-[#1D2739] text-left mb-6 mt-4">
                  {" "}
                  Your current email is <strong>user@email.com</strong>
                </p>
                <label className="text-base text-gray-700 text-left mb-1">
                  New email address
                </label>
                <input
                  type="email"
                  placeholder="Email Address"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  className={`w-full rounded-md p-2 ${
                    error ? "border border-red-500" : "bg-[#F4F4F4]"
                  }`}
                />
                {error && <p className="text-sm text-red-600">{error}</p>}
                <div className="flex flex-col items-center w-full mt-12 space-y-2">
                  <button
                    onClick={handleEmailSubmit}
                    className="bg-[#FFFAFA] text-[#545454] border px-4 py-2 rounded-md w-[382px] flex justify-center items-center"
                  >
                    Send verification code
                  </button>
                  <p className="text-xs text-gray-500 text-center">
                    A verification code will be sent to the new email address.
                  </p>
                </div>
              </>
            ) : (
              <div className="w-full flex flex-col items-center text-center">
                <p className="text-[#1D2739] font-bold text-base mb-12">
                  A verification code has been sent to your email
                </p>
                <button
                  onClick={() => setShowDialog(false)}
                  className="text-[#545454] px-4 py-2 rounded-md border w-[382px]"
                >
                  Go to email
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
